import { Injectable } from '@angular/core';
import {Http, Response} from '@angular/http';
import 'rxjs/Rx';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class CalificacionesService {

  constructor(private http:Http) { }
  getCursos(): Observable<any>{
    return this.http.get('assets/data/cursos.json')
                    .map(
                      (response : Response) => response.json()
                    )
  }
  getIsumos() {
    return this.http.get('assets/data/insumos.json')
                    .map(
                      (response : Response) => response.json()
                    )
  }
  getAnoLectivo(){
    return this.http.get('assets/data/lectivo.json')
                    .map(
                      (response : Response) => response.json()
                    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/calificaciones.service.ts